<template>
  <div class="pop">
    <div class="content">
      <div class="prompt">
        <div class="title">
          <span>{{ $t('lang.versionUpdate.title') }}</span>
        </div>
        <div class="sentence">
          <span>{{ $t('lang.versionUpdate.sentence') }}</span>
        </div>
        <div class="downloadLnk" @click="copyDownloadLnk">
          <input :value="downloadLnk" ref="downloadLnk" readonly type="text" class="lnk"/><span class="copyLnk">{{$t('lang.versionUpdate.btnCopyLnk')}}</span>
        </div>
      </div>
      <div class="downloadBtn" @click="download">{{ $t('lang.versionUpdate.btnClickToDownload') }}</div>
    </div>
    <div class="close" v-show="closeShow" @click="close">
      <img :src="closeBtn"/>
    </div>
  </div>
</template>

<script>
import btn from '@/assets/images/common/landing_button1.gif'
import {Toast} from 'mint-ui'
import store from '../../store/store'
import closeBtn from '@/assets/images/common/updateClose.svg'
import config from '../../../static/config/config'

export default {
  name: 'userGuide',
  props: ['promptType', 'handleClose'],
  data () {
    return {
      btn,
      closeBtn,
      closeShow: false,
      downloadLnk: ''
    }
  },
  mounted () {
    // 2023-07-21 YTW 按照愿意渠道下载 没有渠道默认app15
    const cid = localStorage.getItem('cid') ? localStorage.getItem('cid') : 'app15'
    this.downloadLnk = config.baseURL + 'mobileapp/pge-' + cid + '-' + config.apkVersion + '.apk'
    this.closeShow = true
  },
  methods: {
    download () {
      window.location.href = this.downloadLnk
    },
    copyDownloadLnk () {
      Toast({
        message: this.$t('lang.inviteFriends.success'),
        position: 'middle',
        zIndex: 999999
      })
      let shares = this.downloadLnk
      let copyBehavior = function (e) {
        e.clipboardData.setData('text/plain', shares)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', copyBehavior)
      document.execCommand('copy')
    },
    close () {
      store.commit('setHideVersionUpdatePop', true)
      this.handleClose()
    }
  }
}
</script>

<style lang="less" scoped>
.pop{
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  padding: 40px 20px;
  z-index: 999;
  background-color: rgba(0,0,0,0.3);

  .cancel-btn{
    position: absolute;
    top: 20px;
    right: 20px;
    width: 38px;
    height: 38px;
  }

  .content{
    position: absolute;
    top: 68vw;
    left: 50%;
    transform: translate(-50%);
    width: 80.555vw;
    height: 68.888vw;
    padding: 0 20px;
    text-align: center;
    background: #1C1D1C;
    border: 1px solid #737373;
    border-radius: 4.166vw;

    .prompt{
      .title {
        margin: 5vw auto 7vw auto;
        font-size: 5.833vw;
        font-weight: 700;
        text-align: center;
        color: #FFFFFF;
      }

      .sentence {
        text-align: left;
        font-size: 4.166vw;
        font-weight: 400;
        color: #C4C4C4;
        margin-bottom: 4vw;
      }
    }

    .downloadBtn{
      margin: auto;
      width: 65.833vw;
      height: 10vw;
      line-height: 10vw;
      background: linear-gradient(to right, #EBD0A4 0%, #E1C6A0 25%, #D7BC9C 50%, #DEBD86 75%, #D2B17C 100%);
      color:#000000;
      font-size: 5vw;
      border-radius: 2.222vw;
      font-weight: 700;
      text-align: center;
    }

    .downloadLnk{
      color: #C4C4C4;
      line-height: 30px;
      display: flex;

      .lnk{
        display: none;
        font-size: 10px;
        width: calc(100vw - 140px);
        overflow: hidden;
        white-space: nowrap;
        color: #E0E0E0;
      }

      .copyLnk{
        margin: 2vw auto 6vw auto;
        font-size: 3.611vw;
        font-weight: 400;
        text-align: center;
        text-decoration: underline;
        color: #0583F8;
        opacity: 0.78;
      }
    }
  }

  .close {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    top: 139vw;
    img{
      width: 3.889vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/VersionUpdatePop/index.vue